<template>
    <v-container>
      <v-row>
        <v-col cols="12" class="pa-0 ma-0 mt-2">
          <v-text-field
            label="Email Address"
            v-model="editedItem.emailAdd"
            class="input-text-size pa-0 mt-n1"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="pa-0 ma-0">
          <v-checkbox
            v-model="editedItem.saveEmailToRecord"
            label="Save this email address to the tax record"
            class="input-text-size pa-0 ma-0"
            dense
            hide-details
          ></v-checkbox>
        </v-col>
        <v-col cols="12" class="pa-0 ma-0">
          <v-text-field
            label="BCC"
            v-model="editedItem.bccEmailAddress"
            class="input-text-size pa-0 mt-n1"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="pa-0 ma-0">
          <v-text-field
            label="Subject"
            v-model="editedItem.subjectLine"
            class="input-text-size pa-0 mt-n1"
          ></v-text-field>
        </v-col>
        <v-textarea class="input-text-size pa-0 ma-0" label="Body"
        outlined rows="4" dense v-model="editedItem.subjectBody" />
      </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'EmailStatementDialoge',
  props: {
    baseCrudKey: {
      type: String,
      default: 'emailStatement',
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
    ]),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
  },
};

</script>
